import React from 'react'
import { useMutation } from 'react-query'
import { addVideoReimburse } from '../services'
import { Formik } from 'formik'
import * as Yup from "yup"
import { Grid } from 'material-ui-core'
import { CustomModal } from './modal'
import { Info, WarningRounded } from '@mui/icons-material'

const VideoReimburseModal = ({ isOpen, onClose, onSubmit, video }) => {

    const { mutate: addReimburse, isLoading } = useMutation(reimburse => addVideoReimburse(video?.id, reimburse), {
        onSuccess: () => {
            onClose()
            onSubmit?.()
        },
        onError: error => {
            alert(error.data?.message)
        },
    })

    return (
        <CustomModal
            open={isOpen}
            onClose={onClose}
            className="commonCustomModal feedbackModal"
            body={video ? (
                <div>
                    <h2 className='mb-20'>Video payout breakdown ({video.uid}) [{video.expert_name}]</h2>
                    <Formik
                        enableReinitialize
                        initialValues={{
                            reimburse: video.reimburse_converted.toFixed(2) || 0,
                        }}
                        validationSchema={Yup.object().shape({
                            reimburse: Yup.number().min(0, "Please set a valid amount"),
                        })}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                            addReimburse(Number(values.reimburse));
                            setSubmitting(false);
                        }}
                    >
                        {props => {
                            const {
                                values,
                                touched,
                                setFieldValue,
                                errors,
                                isSubmitting,
                                handleSubmit
                            } = props;

                            return (
                                <form onSubmit={handleSubmit}>
                                    <div className="is-flex aic mb-30">
                                        {video.currency_code} {(video.earning_converted - video.reimburse_converted).toFixed(2)}
                                        {' (Earning amount)'}
                                        <br/>
                                        {video.currency_code} {Number(values.reimburse).toFixed(2)}
                                        {' (Reimburse amount)'}
                                        <br/>
                                        {video.currency_code} {(video.earning_converted - video.reimburse_converted + Number(values.reimburse)).toFixed(2)}
                                        {' (Total payout amount)'}
                                    </div>
                                     <Grid container direction="row" spacing={2}>
                                        <Grid item lg={4}>
                                        </Grid>
                                        <Grid item lg={4}>
                                            <div className="is-flex aic mb-10">
                                                <span className="is-flex mr-10">{video.currency_code}</span>
                                                <input
                                                    type="number"
                                                    className="stllr-input"
                                                    placeholder="Enter Reimburse amount"
                                                    name="reimburse"
                                                    value={values.reimburse}
                                                    onChange={e => setFieldValue('reimburse', e.target.value)}
                                                />
                                            </div>
                                            {errors.reimburse && touched.reimburse ? (
                                                <span className="v-error">{errors.reimburse}</span>
                                            ) : null}
                                        </Grid>
                                        <Grid item lg={4}>
                                            <input
                                                type="submit"
                                                className="stllr-btn primary btn-md ml-20"
                                                disabled={isSubmitting || isLoading}
                                                value="Submit"
                                            />
                                        </Grid>
                                    </Grid>
                                </form>
                            );
                        }}
                    </Formik>

                    {video.is_approved ? <p className="is-flex aic">
                        <WarningRounded color="warning" className="mr-5" fontSize="small" /> This action is not irreversible. it will deposit the amount to the creator's account instantly.
                    </p> : <p className="is-flex aic">
                        <Info color="info" className="mr-5" fontSize="small" /> This action is not immediate. it will be deposited to the creator's account after the video is approved.
                    </p>}
                </div>
            ) : null}
        />
    );
}

export default VideoReimburseModal